module.exports = __webpack_public_path__ + "img/neeco__logo@2x.245b4bf2.png";